import { render, staticRenderFns } from "./FormLogo.vue?vue&type=template&id=6b0eae61&"
import script from "./FormLogo.vue?vue&type=script&lang=js&"
export * from "./FormLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/aalzahr/mwc-components-common/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b0eae61')) {
      api.createRecord('6b0eae61', component.options)
    } else {
      api.reload('6b0eae61', component.options)
    }
    module.hot.accept("./FormLogo.vue?vue&type=template&id=6b0eae61&", function () {
      api.rerender('6b0eae61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LoginForm/FormLogo.vue"
export default component.exports